import React, {Fragment, useContext, useEffect, useRef, useState} from 'react'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../../../../App/stores/RootStore'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { Accordion, Card } from "react-bootstrap";
import { Button, Icon, Label, Popup, Form, Header, Divider } from "semantic-ui-react";
import RequestReviewDocumentNoteForm from '../../../../notes/form/RequestReviewDocumentNote/RequestReviewDocumentNoteForm';
import Moment from "react-moment";

const RequestReviewDocuments: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const { requestReviewDocumentsById, deleteRequestReviewDocument, loadRequestReviewDocuments } = rootStore.requestReviewDocumentStore;
    const { handleSubmit, submitting } = rootStore.requestReviewDocumentAnswerStore;
    const { deleteRequestReviewDocumentNote } = rootStore.requestReviewDocumentNoteStore;
    const { user } = rootStore.userStore;
    const { submitting: submittingDocument } = rootStore.requestReviewDocumentStore;
    const { RequestReview } = rootStore.requestReviewStore;
    const { openModal } = rootStore.modalStore;
    const options = [
        { key: 1, text: 'Yes', value: true },
        { key: 2, text: 'No', value: false }
    ]

    const [inputValues, setInputValues] = useState({});
    const setInputValue = (field: string, value: string) => {
        //console.log(inputValues)
        setInputValues((prevState:any) => ({
            ...prevState,
            [field]: value
        }));
        //console.log(`${field} manually set to:`, value);
    };
    const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>, d:any, field: string) => {
        // console.log(e)
        const value = d.value;
        setInputValue(field, value)

    };
    useEffect(() => {
        //set the text response values
        requestReviewDocumentsById.map(([group, requestReviewDocs])=>(
            requestReviewDocs.map(requestReviewDoc => (
                requestReviewDoc.questions.map((question, index) => (
                    setInputValue(requestReviewDoc.id+question.id, question.answerText??"")
                ))
            ))
        ))
    }, [requestReviewDocumentsById]);
    return (
        <Fragment>
            {requestReviewDocumentsById.map(([group, requestReviewDocs]) => (
                <Fragment key={group}>
                    {requestReviewDocs.map(requestReviewDoc => (
                        <Accordion defaultActiveKey="0" key={requestReviewDoc.id}>
                            <Card>
                                <Card.Header>
                                    <Accordion.Toggle as={Card.Header} variant="link" eventKey="0" className={"accordion-header"} >
                                        <Label as='a'>
                                            <Icon name='file alternate' />
                                            {requestReviewDoc.documentType} - {requestReviewDoc.docCount}
                                        </Label>
                                        {RequestReview?.reviewEnd == null ?
                                            <Popup
                                                content={requestReviewDoc?.noteCount}
                                                trigger={
                                                    <Button size='tiny'
                                                        color='yellow'
                                                        onClick={() => openModal(
                                                            <RequestReviewDocumentNoteForm
                                                                requestReviewDocumentNoteId={''}
                                                                noteType={''}
                                                                requestReviewId={requestReviewDoc.requestReviewId}
                                                                note={''}
                                                                requestReviewDocumentId={requestReviewDoc.id} />)} >
                                                        <Icon name="sticky note" />
                                                    </Button>
                                                }
                                            />
                                            : ""}
                                        {RequestReview?.reviewEnd == null ?
                                            <Popup
                                                content={"Delete this Document"}
                                                trigger={
                                                    <Button size='tiny'
                                                        loading={submittingDocument}
                                                        floated='right'
                                                        color='red'
                                                        onClick={() => deleteRequestReviewDocument(requestReviewDoc.id)} >
                                                        <Icon name="delete" />
                                                    </Button>
                                                }
                                            />
                                            : ""}
                                    </Accordion.Toggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey="0" >
                                    <Card.Body>
                                        <Form id={requestReviewDoc.id} onSubmit={handleSubmit} loading={submitting}>
                                            {requestReviewDoc.questions.map((question, index) => (
                                                <Form.Group key={question.id}>
                                                    <Form.Field id={question.id} className={'document-field'}>
                                                        {/* <tr> */}
                                                        <Label className={'doc-label'} content={question.question} />
                                                        {RequestReview?.reviewEnd == null && question.responseType == "bool"?
                                                            <Form.Select
                                                                id={requestReviewDoc.documentTypeId}
                                                                options={options}
                                                                defaultValue={question.answer}
                                                            />
                                                            : ""}
                                                        {RequestReview?.reviewEnd == null && question.responseType == "string"?
                                                            <Form.Input
                                                                id={requestReviewDoc.documentTypeId}
                                                                // @ts-ignore
                                                                value = {inputValues[requestReviewDoc.id+question.id]}
                                                                onChange={(e, d) => handleTextChange(e,d, requestReviewDoc.id+question.id)}
                                                            />
                                                            : ""}
                                                        {/* </tr> */}
                                                    </Form.Field>
                                                </Form.Group>
                                            ))}
                                            {RequestReview?.reviewEnd == null ?
                                                <Form.Field control={Button} positive disabled={false}>Save </Form.Field>
                                                : ""}
                                        </Form>
                                        <Divider />
                                        <Header as='h3' style={{ margin: '8px' }}>Notes</Header>
                                        {requestReviewDoc.notes.map(note => (
                                            <Form.Group key={note.id}>
                                                <Form.Field id={note.id} className={'note-field'}>
                                                    {RequestReview?.reviewEnd == null ?

                                                        <Button size='tiny'
                                                            className={'rl-btn'}
                                                            disabled={note.createdById != user?.id}
                                                            onClick={() => openModal(
                                                                <RequestReviewDocumentNoteForm
                                                                    note={note.note}
                                                                    requestReviewDocumentNoteId={note.id}
                                                                    noteType={'Document'}
                                                                    requestReviewId={requestReviewDoc.requestReviewId}
                                                                    requestReviewDocumentId={requestReviewDoc.id} />)} >
                                                            <Icon name="edit" />
                                                        </Button>
                                                        : ""}
                                                    {RequestReview?.reviewEnd == null ?
                                                        <Button size='tiny'
                                                            color={'red'}
                                                            disabled={note.createdById != user?.id}
                                                            onClick={() => deleteRequestReviewDocumentNote(note.id)
                                                                .then(r => loadRequestReviewDocuments(requestReviewDoc.requestReviewId))}>
                                                            <Icon name="delete" />
                                                        </Button>
                                                        : ""}
                                                    <Label content={note.note} style={{ maxWidth: '45%' }} />
                                                    {note.createdByName} - <Moment format={'MMM D YYYY'} date={note.dateCreated} />
                                                </Form.Field>
                                            </Form.Group>
                                        ))}
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    ))}
                </Fragment>
            ))}
        </Fragment>
    )
}
export default observer(RequestReviewDocuments);